export default "__VITE_ASSET__BUZX4O8$__"